import { render, staticRenderFns } from "./PostMeta.vue?vue&type=template&id=154cfc1e&"
import script from "./PostMeta.vue?vue&type=script&lang=js&"
export * from "./PostMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports